<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.asId" filterable clearable @change="partserch"
                        placeholder="请选择" style="width: 180px;">
                        <el-option v-for="(item, index) in getAjefShopList_data" :key="index" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.outBillNo" style="width: 150px;" size="mini" placeholder="商户单号"
                        clearable></el-input>
                    <!--开始时间  -->
                    <el-date-picker v-model="formDatas.dateStart" type="datetime" placeholder="开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss" size="mini" clearable style="width: 160px;"
                        @change="partserch">
                    </el-date-picker>
                    <!--结束时间  -->
                    <el-date-picker v-model="formDatas.dateEnd" type="datetime" placeholder="结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss" size="mini" clearable style="width: 160px;"
                        @change="partserch">
                    </el-date-picker>
                    <el-select size="mini" v-model="formDatas.aawType" clearable @change="partserch" placeholder="请选择类型"
                        style="width: 130px">
                        <el-option label="对公打款" :value="2" key="2"></el-option>
                        <el-option label="微信转账" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.aawStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="成功" :value="2" key="2"></el-option>
                        <el-option label="创建" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.wxTransferStatusDes" style="width: 150px;" size="mini"
                        placeholder="微信转账状态描述" clearable></el-input>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out2()">导出记录</el-button>
                    <el-button v-if="formDatas.aawType == 2" type="warning" size="mini" style="margin-right: 10px;"
                        @click="Out()">导出待处理对公打款</el-button>
                    <el-button type="success" size="mini" style="margin-left: 10px"
                        v-if="(formDatas.aawStatus == 1 || formDatas.aawStatus == 3) && formDatas.aawType == 2 && selectedRowKeysCollection.length > 0"
                        @click="handleAdd({}, 2)">批量处理对公打款</el-button>
                    <el-button type="success" size="mini" style="margin-left: 10px"
                        v-if="formDatas.aawStatus == 2 && formDatas.aawType == 2 && selectedRowKeysCollection.length > 0"
                        @click="handleEdit({}, 2)">批量编辑对公打款</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增商户</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="aawId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑对公打款信息' : '新增对公打款信息'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="打款描述" prop="aawDes">
                                <el-input v-model="form.aawDes" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="打款截图" prop="aawReturn">
                                <my-uploadOnly ref="upload" @fileChange="fileChange" :filearr="fileList" :limit="1"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="打款时间" prop="handlerTime">
                                <el-date-picker v-model="form.handlerTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="对公每刻单号" prop="handleMeikeNo">
                                <el-input v-model="form.handleMeikeNo" style="width: 80%;"
                                    placeholder="请输入名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { updateAjefApplyWithdrawPaymentMulti, updateAjefApplyWithdrawPaymentDesMulti, getAjefApplyWithdrawList, updateAjefApplyWithdrawPaymentDes, updateAjefApplyWithdrawPayment, deleteAjefShop, getAjefShopListQuick } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            fileList: [],
            getAjefShopList_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            statusAll: [
                { id: 1, name: "闲置" },
                { id: 2, name: "领用" },
                { id: 3, name: "损坏" },
                { id: 4, name: "丢失" },
            ],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'aawId',
            dialog: false,
            edit: false,
            form: {
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                    fixed: "left",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "店铺",
                    align: "center",
                    fixed: "left",
                    width: 120,
                    edit: false,
                },

                {
                    field: "aawStatus",
                    key: "aawStatus",
                    title: "状态",
                    edit: false,
                    align: "center",
                    fixed: "left",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aawStatus == 1 ? <el-tag size="mini" type="success">创建</el-tag> :
                                        row.aawStatus == 2 ? <el-tag size="mini" >成功</el-tag> :
                                            <el-tag type="danger" size="mini">失败</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "asStatusBankCheck",
                    key: "asStatusBankCheck",
                    title: "对公打款信息校验",
                    align: "center",
                    edit: false,
                    fixed: "left",
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {

                                    row.asStatusBankCheck == 1 ? <el-tag size="mini" >未校验</el-tag> :
                                        row.asStatusBankCheck == 2 ? <el-tag size="success" size="mini">校验成功</el-tag> :
                                            ''

                                }

                            </span>
                        );
                    },
                },
                {
                    field: "aawType",
                    key: "aawType",
                    title: "申请类型",
                    align: "center",
                    // fixed: "left",
                    edit: false,
                    width: 150,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aawType == 1 ? <el-tag size="mini" type="success">微信转账</el-tag> :
                                        <el-tag type="danger" size="mini">对公打款</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "aawMoney",
                    key: "aawMoney",
                    title: "申请金额(分)",
                    align: "center",
                    width: 160,
                    edit: false,
                },
                {
                    field: "aawMoneyYuan",
                    key: "aawMoneyYuan",
                    title: "申请金额(元)",
                    align: "center",
                    width: 160,
                    edit: false,
                },
                {
                    field: "userId",
                    key: "userId",
                    title: "小程序用户ID",
                    align: "center",
                    width: 120,
                    edit: false,
                },
                {
                    field: "openId",
                    key: "openId",
                    title: "小程序用户openid",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "aawName",
                    key: "aawName",
                    title: "申请人名称",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "aawResult",
                    key: "aawResult",
                    title: "提现处理结果描述",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "aawDes",
                    key: "aawDes",
                    title: "打款描述",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "handleMeikeNo",
                    key: "handleMeikeNo",
                    title: "对公每刻单号",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "aawReturn",
                    key: "aawReturn",
                    title: "打款截图",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:100%;">
                                    {
                                        row.aawReturn ? row.aawReturn.split(',').map((item => {
                                            const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                                previewSrcList={[item]}></el-image>
                                            return str
                                        })) : ''
                                    }

                                </div>
                            </span>
                        );
                    },
                },
                {
                    field: "outBillNo",
                    key: "outBillNo",
                    title: "商户单号",
                    align: "center",
                    edit: false,
                    width: 260,
                },
                {
                    field: "transferBillNo",
                    key: "transferBillNo",
                    title: "微信转账单号",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "createTime",
                    key: "createTime",
                    title: "单据创建时间",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "state",
                    key: "state",
                    title: "单据状态",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "packageInfo",
                    key: "packageInfo",
                    title: "跳转领取页面的package信息",
                    align: "center",
                    edit: false,
                    width: 230,
                },
                {
                    field: "wxTransferStatus",
                    key: "wxTransferStatus",
                    title: "微信转账状态",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.wxTransferStatus == 1 && row.aawType == 1 ? <el-tag size="mini" type="danger">用户申请</el-tag> :
                                        row.wxTransferStatus == 2 && row.aawType == 1 ? <el-tag size="mini" type="danger">已转账待用户接受</el-tag> :
                                            row.wxTransferStatus == 3 && row.aawType == 1 ? <el-tag size="mini" type="danger">后台确认用户是否接收中</el-tag> :
                                                row.wxTransferStatus == 4 && row.aawType == 1 ? <el-tag size="mini" type="success">用户已接收</el-tag> :
                                                    row.wxTransferStatus == 5 && row.aawType == 1 ? <el-tag type="danger" size="mini">失败</el-tag> : ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "wxTransferStatusDes",
                    key: "wxTransferStatusDes",
                    title: "微信转账状态描述",
                    align: "center",
                    edit: false,
                    width: 420,
                },

                { field: "handlerusername", key: "handlerusername", title: "处理人", width: 160, align: "center" },
                { field: "handlerTime", key: "handlerTime", title: "处理时间", width: 160, align: "center" },
                { field: "aawCreatetime", key: "c", title: "创建时间", width: 160, fixed: 'right', align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 90,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.aawStatus != 2 && row.aawType == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleAdd(row, 1)}
                                    >
                                        对公打款
                                    </el-button> : ''
                                }
                                {
                                    row.aawStatus == 2 && row.aawType == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleEdit(row, 1)}
                                    >
                                        编辑对公打款
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
            this.getAjefShopList_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        Out2() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-apply-withdraw/exportAjefApplyWithdraw',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '提现记录.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-apply-withdraw/exportAjefApplyWithdrawPayment',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '待处理对公打款申请.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        fileChange(file) {
            if (this.form.aawReturn.length > 0) {
                file.forEach((item, index) => {
                    if (this.form.aawReturn.indexOf(item) == -1) {
                        this.form.aawReturn.push(item);
                        const s = {
                            url: item,
                            name: item
                        }
                        this.fileList.push(s)
                    }
                })
            } else {
                this.$set(this.form, 'aawReturn', file)
                  file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter(file) {
            const url = this.form.aawReturn.findIndex(item => item === file)
            this.form.aawReturn.splice(url, 1)
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ aawId: this.theRow.aawId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjefShop({ aawIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjefShop({ aawId: row.aawId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleAdd(row, type) {
            this.theType = type
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.aawReturn = []
            })
        },
        handleEdit(row, type) {
            this.theType = type;
            if (type == 1) {
                const data = JSON.parse(JSON.stringify(row))
                this.dialog = true;
                this.edit = true;
                this.$nextTick(() => {
                    this.form = data;
                    this.form.aawReturn = data.aawReturn ? data.aawReturn.split(',') : [];
                    if (data.aawReturn.length > 0) {
                        this.form.aawReturn.forEach((item, index) => {
                            const img = {
                                name: item,
                                url: item,
                            }
                            this.$set(this.fileList, index, img)
                        })
                    }
                })
            } else {
                this.dialog = true;
                this.edit = true;
                this.form = {};
                this.form.aawReturn = []
            }

        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.aawReturn = newForm.aawReturn.toString()
                        if (this.theType == 2) {
                            newForm.aawIds = this.selectedRowKeysCollection.toString()
                            updateAjefApplyWithdrawPaymentMulti(newForm).then(res => {
                                if (res.data) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功!",
                                    });
                                    this.handleClose()
                                    this.getList()
                                }
                            })
                            return
                        }
                        updateAjefApplyWithdrawPayment(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.aawReturn = newForm.aawReturn.toString()
                        if (this.theType == 2) {
                            newForm.aawIds = this.selectedRowKeysCollection.toString()
                            updateAjefApplyWithdrawPaymentDesMulti(newForm).then(res => {
                                if (res.data) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功!",
                                    });
                                    this.handleClose()
                                    this.getList()
                                }
                            })
                            return
                        }
                        updateAjefApplyWithdrawPaymentDes(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.theType = null;
            this.fileList = [];
            this.checkboxOption.selectedRowKeys = [];
            this.selectedRowKeysCollection = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.aawId = row.aawId
                    console.log(jsonObj);
                    updateAjefApplyWithdrawPayment(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjefApplyWithdrawList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefApplyWithdrawList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjefApplyWithdrawList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>